export default __webpack_public_path__ + "static/media/menu3.5d72a773.svg";